'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.shallowEquals = shallowEquals;
exports.isEmpty = isEmpty;

var _immutable = require('immutable');

var _immutable2 = _interopRequireDefault(_immutable);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var is = _immutable2.default.is.bind(_immutable2.default);

/* Implementation of shallowEquals that supports ImmutableJS structures */
function shallowEquals(a, b) {
  if (a === b || is(a, b)) {
    return true;
  }

  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) !== 'object' || a === null || (typeof b === 'undefined' ? 'undefined' : _typeof(b)) !== 'object' || b === null) {
    return false;
  }

  var keysA = Object.keys(a);
  var keysB = Object.keys(b);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
  // eslint-disable-next-line no-restricted-syntax
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = keysA[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var key = _step.value;

      if (!bHasOwnProperty(key) || !is(a[key], b[key])) {
        return false;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return true;
}

/* isEmpty that supports both native arrays/objects and Immutable iterables (lists, maps, etc) */
function isEmpty(obj) {
  if (_immutable2.default.Iterable.isIterable(obj)) {
    return obj.isEmpty();
  }

  return _lodash2.default.isEmpty(obj);
}


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/utils/immutable/lib/index.js
// module id = 73
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14